import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function NewsSection() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">体育资讯</h2>
            <p className="text-foreground-600 text-sm">掌握最新体育动态和深度分析</p>
          </div>
          <Link
            to="/category/tiyuzixun"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {latestArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 ${
                idx === 0 ? "md:col-span-2" : ""
              }`}
            >
              <div className={`flex flex-col ${idx === 0 ? "md:flex-row" : ""}`}>
                <div className={`overflow-hidden ${idx === 0 ? "md:w-2/5 md:h-56" : "h-48"}`}>
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className={`p-5 ${idx === 0 ? "md:w-3/5 md:flex md:flex-col md:justify-center" : ""}`}>
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3 flex-wrap">
                    <span>{article.publishDate}</span>
                    <span>·</span>
                    <span>{article.readTime}阅读</span>
                    <span>·</span>
                    <span>{article.author}</span>
                  </div>
                  <h3 className={`font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2 ${
                    idx === 0 ? "text-lg md:text-xl" : "text-sm"
                  }`}>
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center gap-2 mt-3 flex-wrap">
                    {article.tags.map((tag) => (
                      <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}